import { __assign, __rest } from "tslib";
import React, { useState, useEffect } from "react";
import { EState } from "./Image.types";
var ReactImage = function (props) {
    var src = props.src, alt = props.alt, _a = props.errorImage, errorImage = _a === void 0 ? "https://raw.githubusercontent.com/MuhammadUmar01/simple-react-image/main/src/static/error.png" : _a, _b = props.fallback, fallback = _b === void 0 ? "https://raw.githubusercontent.com/MuhammadUmar01/simple-react-image/main/src/static/loading.png" : _b, onStateChange = props.onStateChange, referrerPolicy = props.referrerPolicy, rest = __rest(props, ["src", "alt", "errorImage", "fallback", "onStateChange", "referrerPolicy"]);
    var _c = useState(false), loaded = _c[0], setLoaded = _c[1];
    var _d = useState(false), error = _d[0], setError = _d[1];
    useEffect(function () {
        onStateChange && onStateChange(EState.loading);
        setLoaded(false);
        setError(false);
        var image = new Image();
        image.onload = function () {
            setLoaded(true);
            onStateChange && onStateChange(EState.loaded);
        };
        image.onerror = function (_err) {
            setError(true);
            onStateChange && onStateChange(EState.error);
        };
        image.src = src;
        if (referrerPolicy) {
            image.referrerPolicy = referrerPolicy;
        }
        // eslint-disable-next-line
    }, [props.src]);
    var imgSrc = loaded ? src : fallback;
    return React.createElement("img", __assign({ src: error ? errorImage : imgSrc, alt: alt }, rest));
};
export default ReactImage;
